import { CeruleanButton } from 'components/Button'
import iconColor from 'components/iconColor'
import FasCheck from 'components/Legacy/Icons/FasCheck'
import messages from 'lang'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import styled from 'styled-components'
import { color, px } from 'utils'

import Container from '../Modal/Container'

const SuccessWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: center;

  & button {
    padding: 1rem;
  }
`

const Row = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16rem 3rem;
`

const GreenCheckWrapper = styled.div`
  height: 72px;
  width: 72px;
  background-color: ${color('green400')};
  border-radius: 50%;
  margin-bottom: 1rem;
`

const Check = styled(FasCheck)`
  ${iconColor('white')};
  margin: 14px 3px 3px 4px;
`

const SuccessHeader = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  padding-bottom: 0.8rem;
`

const SuccessSubHeader = styled.div`
  font-size: 0.9rem;
`

const AppComplete = ({ intl }: WrappedComponentProps) => {
  return (
    <SuccessWrapper>
      <Row>
        <GreenCheckWrapper>
          <Check size={px(3)} />
        </GreenCheckWrapper>
        <SuccessHeader>{intl.formatMessage(messages.application_complete)}</SuccessHeader>
        <SuccessSubHeader>{intl.formatMessage(messages.application_received)}</SuccessSubHeader>
      </Row>
      <CeruleanButton e2e='applicationCompleteDoneButton' type='submit'>
        {intl.formatMessage(messages.button_done)}
      </CeruleanButton>
    </SuccessWrapper>
  )
}

export default injectIntl(AppComplete)
